/* eslint-disable react/prop-types */
import React from 'react';
import classnames from 'classnames';
import { Icon, DefaultButton } from '@bingads-webui-react/fabric-control';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { CustomFluentUIIcons } from '@bingads-webui-campaign-react/asset-library-resources';

import { getBannerStyles } from './banner-styles';

const NewFeatureBanner = ({
  content,
  classes,
  i18n,
  bannerClassName,
}) => (
  <div className={classnames(classes.assetLibraryNewFeatureBanner, bannerClassName, 'asset-library-new-feature-banner')} >
    <span className="new-feature-icon" />
    <span className="new-feature-label">{i18n.getString(_TL_('New feature!'))}</span>
    <div className="new-feature-content">
      {content}
    </div>
  </div>
);

export const AssetLibraryNewFeatureBanner = withDefaultStyles(NewFeatureBanner, getBannerStyles);

const AIGCPromotionBanner = ({ onGenerateImagesClick, classes, i18n }) => (
  <div className={classnames(classes.assetLibraryAIGCPromotionBanner)} >
    <div className="asset-library-aigc-banner-background" />
    <div className="asset-library-aigc-banner-content" >
      <Icon className="aigc-banner-icon" iconName={CustomFluentUIIcons.CopilotSVGIcon} />
      <div className="aigc-banner-texts">
        <div className="aigc-banner-title">
          <span>{i18n.getString(_TL_('Create high-quality imagery with AI'))}</span>
        </div>
        <div className="aigc-banner-description">
          <span>{i18n.getString(_TL_('You can generate custom images for your ads with ease, powered by AI.'))}</span>
        </div>
      </div>
    </div>
    <div className="aigc-images">
      <DefaultButton id="aigc-generate-images-button" aria-label={i18n.getString(_TL_('Generate images button'))} text={i18n.getString(_TL_('Generate images'))} onClick={onGenerateImagesClick} />
    </div>
  </div>
);

export const AssetLibraryAIGCPromotionBanner = withDefaultStyles(AIGCPromotionBanner, getBannerStyles);
